// export DsfScheduleListItem from "./scheduleListItem.vue";
export const DsfScheduleListItem = dsf.defineAsyncComponent("DsfScheduleListItem", () => import(/*webpackChunkName:"platform_homepage"*/ "./scheduleListItem.vue"));
